// Utility functions for setting URL parameters.
/* eslint prefer-arrow-callback: 0  */
/* eslint no-nested-ternary: 0  */
/**
 * @param {string} searchString
 * @return {string} a single url parameter
 */
export const extractParameter = (searchString) => (name) => {
	name = String(name).replace(/(\[|\])/g, '\\$1');
	const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
	const results = regex.exec(searchString);
	return results === null ? '' : results[1];
};

/**
 * @param {string} parameter name
 * @return {string} parameter value
 *
 * gup :: String -> String
 */

export const gup = extractParameter(window.location.href);

/**
 * @param {Object} object Object of url params
 * @return {string} &-separated parameter string with encoded params
 */
export const encodeParameterString = (object = {}) =>
	Object.keys(object).reduce((string, param) => {
		if (string !== '') {
			string += '&';
		}
		return string.concat(
			encodeURIComponent(param) + '=' + encodeURIComponent(object[param])
		);
	}, '');

// fixes a few doubly encoded cases
// sanitizeParams :: String -> String
export function sanitizeParams(string) {
	return String(string || '').replace(/[&"'<>)(]/g, function(c) {
		return c === '&'
			? '&amp;'
			: c === '"'
				? '&quot;'
				: c === "'"
					? '&#039;'
					: c === '<'
						? '&lt;'
						: '&gt;';
	});
}
export const toBooleanStrict = (str) => {
	switch (str) {
		case 'true':
			return true;
		case 'false':
			return false;
		default:
			return str;
	}
};

export const processParams = (x) =>
	toBooleanStrict(sanitizeParams(window.decodeURIComponent(x)));

// gets all url params as an object
// decodeParameterString :: String -> Object
export function decodeParameterString(str) {
	const obj = {};
	String(str)
		.replace('?', '')
		.replace(/&amp;/gi, '&')
		.replace(/([^=&]+)=([^&]*)/g, function(m, key, value) {
			obj[decodeURIComponent(key)] = processParams(value);
		});
	return obj;
}
